export default __webpack_public_path__ + "2b5e086675e86b26c738b86123e1f4fc.png";